import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MojoAvatarModule } from 'mojo-avatar';


import { UserCardComponent } from './user-card.component';

@NgModule({
  imports: [CommonModule, MojoAvatarModule],
  declarations: [UserCardComponent],
  exports: [UserCardComponent]
})
export class UserCardModule { }
